export default __webpack_public_path__ + "static/media/01.24a5642e.jpg";